<template>
    <v-content>
        <v-container>
            <v-card flat class="pa-3">
                <v-layout row wrap>
                    <v-flex md12>
                        <v-layout row wrap>
                            <v-flex md6>
                                <amplify-photo-picker v-bind:photoPickerConfig="photoPickerConfig"></amplify-photo-picker>
                            </v-flex>
                            <v-flex md6>
                                <amplify-s3-image class="pt-5" v-bind:imagePath="icon" v-bind:key="icon"></amplify-s3-image>
                            </v-flex>
                        </v-layout>
                        <input type="hidden" v-model="icon">
                        <v-select v-model="role" :items="roles" label="Role"></v-select>
                        <v-text-field v-model="title" :rules="titleRules" label="Title" required></v-text-field>
                        <v-text-field v-model="link" :rules="linkRules" label="Link" required></v-text-field>
                        <v-text-field v-model="des" :rules="desRules" label="Description" required></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row justify-end>
                        <v-btn class="ma-0 my-3" large color="info" @click="editForm()">Submit</v-btn>
                </v-layout>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { AmplifyEventBus } from 'aws-amplify-vue';
    export default {
        data() {
            return {
                linkImage:'',
                roles: ['Manager', 'Teacher', 'Student'],
                valid: false,
                role: '',
                routerRole: this.$router.history.current.params.role,
                icon: '',
                name: '',
                title: '',
                titleRules: [
                    v => !!v || 'Title is required',
                ],
                link: '',
                linkRules: [
                    v => !!v || 'Link is required',
                ],
                des: '',
                desRules: [
                    v => !!v || 'Description is required',
                ],
                photoPickerConfig: {
                    path: 'icon',
                    header: "Icon upload",
                }
            }
        },

        created() {
            AmplifyEventBus.$on('fileUpload', (data) => {
                this.icon = data;
            });
        },

        watch: {
            currentEdit: {
                handler: function(value) {
                    this.icon = value.metaData.icon;
                    this.role = value.role[0].toUpperCase() + value.role.substring(1);
                    this.name = value.metaData.name;
                    this.title = value.title;
                    this.link = value.link;
                    this.des = value.descriptions;
                },
                immediate: true
            },
        },

        methods: {
            editForm() {
                const pack = {
                    relationId: "techkids",
                    id: "1544814915334",
                    role: this.role.toLowerCase(),
                    dataDetails: {},
                    descriptions: this.des,
                    link: this.link,
                    metaData: {
                        icon: this.icon,
                        name: this.name
                    },
                    title: this.title,
                    widgets: {}
                };
                this.callAppEdit(pack);
                this.$router.push(`/app/${this.role.toLowerCase()}`);
            },
            ...mapActions('users', ['callAppEdit'])
        },

        computed: {
            ...mapGetters('users', ['currentEdit'])
        }
    }
</script>

<style scoped>

</style>